export default __webpack_public_path__ + "static/national-metric-mobile-50d526aa69431fa6c82dfb97fd86f135.svg";